<template>
    <Teleport to="body">
        <Transition name="vip-modal">
            <div v-if="visible" class="vip-overlay" @click="handleOverlayClick">
                <div class="vip-container" @click.stop>
                    <!-- 左侧会员专享功能 -->
                    <div class="vip-left-panel">
                        <div class="vip-header">
                            <h2 class="vip-title">开通会员, 专享特权</h2>
                            <p class="vip-subtitle">-还可拥有会员专享8大权益-</p>
                        </div>
                        
                        <div class="benefits-grid">
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">智能抠图</div>
                                    <div class="benefit-desc">一键去除背景</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">智能消除</div>
                                    <div class="benefit-desc">杂物噪点轻松去</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">图片转矢量</div>
                                    <div class="benefit-desc">图片转矢量图</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">去水印</div>
                                    <div class="benefit-desc">轻松去水印</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">vi图生成</div>
                                    <div class="benefit-desc">一键生成vi图</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">logo设计</div>
                                    <div class="benefit-desc">aI生成logo</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">ai生成海报</div>
                                    <div class="benefit-desc">ai生成海报</div>
                                </div>
                            </div>
                            <div class="benefit-card">
                                <img src="@/assets/static/img2/gougou2x.png" alt="勾选" class="benefit-icon">
                                <div class="benefit-content">
                                    <div class="benefit-title">ai生成名片</div>
                                    <div class="benefit-desc">ai生成名片</div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="login-status">
                            <div class="user-avatar-small">
                                <img :src="userInfo.avatar || defaultAvatar" alt="用户头像">
                            </div>
                            <div class="login-info">
                                <div v-if="userInfo.phone" class="login-text">{{ userInfo.nickname || userInfo.phone || '用户' }}</div>
                                <div v-else class="login-text">还未登录</div>
                                <div v-if="userInfo.phone" class="login-desc">已绑定账号：{{ userInfo.phone }}</div>
                                <div v-else class="login-desc">请先登陆账号</div>
                            </div>
                            <div v-if="!userInfo.phone" class="login-link" @click="handleLogin">前去登陆</div>
                        </div>
                    </div>

            <!-- 右侧用户信息和套餐选择 -->
            <div class="vip-right-panel">



                <div class="plan-selection-container">
                    <div class="plan-selection" ref="planContainer">
                        <div v-if="loading" class="loading-container">
                            <div class="loading-spinner"></div>
                            <div class="loading-text">加载套餐中...</div>
                        </div>
                        <template v-else>
                            <div
                                v-for="plan in vipPlans"
                                :key="plan.id"
                                class="plan-wrapper"
                                @click="selectedPlan = plan.id"
                            >
                                <div v-if="plan.limitedOffer" class="offer-badge">限时优惠</div>
                                <div v-if="plan.recommended" class="recommend-badge">强烈推荐</div>
                                
                                <div
                                    class="plan-card"
                                    :class="{ 
                                        active: selectedPlan === plan.id, 
                                        recommended: plan.recommended,
                                        'limited-offer': plan.limitedOffer 
                                    }"
                                >
                                <div class="plan-header">
                                    <div class="plan-name">{{ plan.name }}</div>
                                    <div class="plan-description">
                                        每月赠送330颗豆豆
                                    </div>
                                </div>
                                
                                <div class="plan-price-section">
                                    <div class="current-price">
                                        <span class="currency-symbol">¥</span>
                                        <span class="price-number">{{ plan.price }}</span>
                                    </div>
                                    <div v-if="plan.originalPrice" class="original-price">原价¥{{ plan.originalPrice }}</div>
                                </div>
                                

                                
                                <div class="plan-details">
                                    <div class="price-per-day">¥{{ plan.dailyPrice }}/天，有效期{{ plan.durationDays }}天</div>
                                </div>
                            </div>
                        </div>
                        </template>
                    </div>
                </div>

                <div class="payment-section">
                    <div class="payment-content">
                        <div class="qr-code">
                            <div class="qr-placeholder" v-if="!paymentData.ewm || qrCodeLoading">
                                <div v-if="qrCodeLoading" class="loading-container">
                                    <div class="loading-spinner"></div>
                                    <div class="loading-text">正在生成支付二维码...</div>
                                </div>
                                <div v-else class="qr-mock"></div>
                            </div>
                            <img v-else :src="paymentData.ewm" class="qr-image" alt="支付二维码">
                        </div>
                        
                        <div class="payment-methods-section">
                            <div class="payment-info">
                                <div class="payment-amount-text">
                                    支付: <span class="currency-symbol">¥</span><span class="price-number">{{ getSelectedPlanPrice() }}</span>
                                </div>
                            </div>
                            
                            <div class="payment-methods">
                                <div 
                                    class="payment-method" 
                                    :class="{ active: selectedPaymentMethod === 'wechat' }"
                                    @click="selectPaymentMethod('wechat')"
                                >
                                    <img src="@/assets/static/images/微信支付.png" alt="微信支付" class="payment-icon">
                                    <span>微信支付</span>
                                </div>
                                <div 
                                    class="payment-method" 
                                    :class="{ active: selectedPaymentMethod === 'alipay' }"
                                    @click="selectPaymentMethod('alipay')"
                                >
                                    <img src="@/assets/static/images/alipay.png" alt="支付宝" class="payment-icon">
                                    <span>支付宝</span>
                                </div>
                            </div>
                            
                            <div v-if="countdown > 0" class="payment-countdown">
                                剩余支付时间：{{ formatCountdown }}
                            </div>
                            
                            <div class="agreement">
                                支付既视为同意《<a href="#" class="agreement-link">问鼎会员服务协议</a>》
                            </div>
                        </div>
                    </div>
                    
                    <div class="action-buttons">
                        <button class="cancel-btn" @click="handleClose">取消开通</button>
                        <button class="invoice-btn">我要开票</button>
                        <button class="complete-payment-btn" @click="handleConfirm">已完成付款并开通</button>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import { defineComponent, ref, watch, onMounted, onUnmounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getVipPackagesApi, vipCreateOrderApi, createTransactionApi, payApi, queryPayApi, wxPayApi, wxQueryPayApi } from '@/api/index'

export default defineComponent({
    name: 'VipModal',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        userInfo: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['update:modelValue', 'confirm', 'login', 'updateUserInfo'],
    setup(props, { emit }) {
        const visible = ref(props.modelValue)
        const selectedPlan = ref(null)
        const defaultAvatar = require('@/assets/static/images/avatar.png')
        const loading = ref(false)
        const vipPlans = ref([])
        const planContainer = ref(null)
        const showLeftArrow = ref(false)
        const showRightArrow = ref(false)
        const isScrolling = ref(false) // 防抖标志
        const savedScrollLeft = ref(0) // 保存滚动位置
        
        // 支付相关状态
        const selectedPaymentMethod = ref('wechat')
        const qrCodeLoading = ref(false)
        const countdown = ref(0)
        let countdownTimer = null
        let paymentCheckTimer = null
        let createOrderTimeout = null // 创建订单的延迟定时器
        const isComponentDestroyed = ref(false) // 组件销毁标志
        
        const paymentData = ref({
            gid: '',
            price: 0,
            oid: '',
            tid: '',
            ewm: ''
        })

        // 获取VIP套餐列表
        const fetchVipPlans = async () => {
            loading.value = true
            try {
                const response = await getVipPackagesApi({})
                
                if (response.data.success) {
                    // 转换API数据为组件需要的格式
                    vipPlans.value = response.data.data.map((plan, index) => ({
                        id: plan.gid,  // 使用gid作为id
                        name: plan.package_name,
                        price: parseFloat(plan.current_price)/100,
                        originalPrice: parseFloat(plan.original_price),
                        dailyPrice: (parseFloat(plan.current_price) / parseInt(plan.duration_days)).toFixed(2),
                        durationDays: parseInt(plan.duration_days),
                        features: plan.features.split(','),
                        description: plan.description,
                        packageType: plan.package_type,
                        // 设置推荐标签（年卡）
                        recommended: plan.package_type === '3',
                        // 设置限时优惠标签（月卡）
                        limitedOffer: plan.package_type === '1',
                        // 根据套餐类型设置额外信息
                        monthlyInfo: plan.package_type === '1',
                        yearlyDiscount: plan.package_type === '3'
                    }))
                    
                    // 默认选中年卡
                    const yearPlan = vipPlans.value.find(plan => plan.packageType === '3')
                    if (yearPlan) {
                        selectedPlan.value = yearPlan.id
                    } else if (vipPlans.value.length > 0) {
                        selectedPlan.value = vipPlans.value[0].id
                    }
                } else {
                    ElMessage.error('获取VIP套餐失败：' + response.data.msg)
                }
            } catch (error) {
                console.error('获取VIP套餐失败:', error)
                ElMessage.error('获取VIP套餐失败，请稍后重试')
            } finally {
                loading.value = false
            }
        }

        watch(() => props.modelValue, (newVal) => {
            visible.value = newVal
        })

        const handleVisibilityChange = (value) => {
            emit('update:modelValue', value)
        }

        const handleLogin = () => {
            // 关闭VIP弹窗
            emit('update:modelValue', false)
            
            // 触发登录事件，让父组件处理登录逻辑
            emit('login')
        }

        const handleClose = () => {
            // 清理支付相关状态和定时器
            cleanupPayment()
            
            // 重置为年卡或第一个套餐
            const yearPlan = vipPlans.value.find(plan => plan.packageType === '3')
            selectedPlan.value = yearPlan ? yearPlan.id : (vipPlans.value.length > 0 ? vipPlans.value[0].id : null)
            emit('update:modelValue', false)
        }

        const handleOverlayClick = () => {
            handleClose()
        }

        const handleConfirm = async () => {
            if (!selectedPlan.value) {
                ElMessage.warning('请选择VIP套餐')
                return
            }
            
            if (!paymentData.value.oid) {
                ElMessage.warning('正在创建订单，请稍候...')
                await createVipOrder()
                return
            }
            
            // 检查支付状态
            checkPaymentStatus()
        }

        const getSelectedPlanPrice = () => {
            if (!selectedPlan.value) return 0
            const plan = vipPlans.value.find(p => p.id === selectedPlan.value)
            return plan ? plan.price : 0
        }

        // 特性名称转换
        const getFeatureName = (feature) => {
            const featureMap = {
                'high_quality': '高清无损',
                'watermark_free': '无水印',
                'priority_support': '优先支持',
                'batch_download': '批量下载',
                'api_access': 'API访问',
                'custom_template': '自定义模板'
            }
            return featureMap[feature] || feature
        }

        // 获取账号类型名称
        const getAccountTypeName = (genre) => {
            const typeMap = {
                '1': '普通用户',
                '2': 'VIP会员',
                '3': '代理用户',
                '4': '商家用户'
            }
            return typeMap[genre] || '普通用户'
        }

        // 统一清理支付相关状态和定时器
        const cleanupPayment = () => {
            // 清理所有定时器
            if (countdownTimer) {
                clearInterval(countdownTimer)
                countdownTimer = null
            }
            if (paymentCheckTimer) {
                clearInterval(paymentCheckTimer)
                paymentCheckTimer = null
            }
            if (createOrderTimeout) {
                clearTimeout(createOrderTimeout)
                createOrderTimeout = null
            }
            
            // 清理支付状态
            paymentData.value = {
                gid: '',
                price: 0,
                oid: '',
                tid: '',
                ewm: ''
            }
            countdown.value = 0
            qrCodeLoading.value = false
        }

        // 创建VIP订单
        const createVipOrder = async () => {
            if (!selectedPlan.value || isComponentDestroyed.value) return
            
            qrCodeLoading.value = true
            try {
                const data = {
                    gid: selectedPlan.value
                }
                
                const res = await vipCreateOrderApi(data)
                console.log('VIP订单创建结果:', res)
                
                if (res.data.success) {
                    paymentData.value.gid = selectedPlan.value
                    paymentData.value.price = res.data.price || (getSelectedPlanPrice() * 100) // 转换为分单位传递给支付接口
                    paymentData.value.oid = res.data.oid
                    
                    // 创建交易
                    await createTransaction()
                } else {
                    ElMessage.error(res.data.msg || '创建订单失败')
                    qrCodeLoading.value = false
                }
            } catch (error) {
                console.error('创建VIP订单失败:', error)
                ElMessage.error('创建订单失败，请稍后重试')
                qrCodeLoading.value = false
            }
        }

        // 创建交易
        const createTransaction = async () => {
            try {
                const data = {
                    order_list: [paymentData.value.oid],
                    genre: '5' // VIP套餐类型
                }

                const res = await createTransactionApi(data)
                if (res.data.success) {
                    paymentData.value.price = res.data.price
                    paymentData.value.tid = res.data.tid

                    // 根据支付方式生成二维码
                    if (selectedPaymentMethod.value === 'alipay') {
                        await handleAlipay()
                    } else {
                        await handleWxPay()
                    }
                } else {
                    ElMessage.error('创建交易失败')
                    qrCodeLoading.value = false
                }
            } catch (error) {
                console.error('创建交易失败:', error)
                ElMessage.error('创建交易失败')
                qrCodeLoading.value = false
            }
        }

        // 支付宝支付
        const handleAlipay = async () => {
            try {
                const data = {
                    out_trade_no: paymentData.value.tid,
                    amount: paymentData.value.price
                }

                const res = await payApi(data)
                if (res.data.alipay_trade_precreate_response.code == '10000') {
                    paymentData.value.ewm = 'data:image/png;base64,' + res.data.alipay_trade_precreate_response.qr_codeimg
                    qrCodeLoading.value = false
                    startPaymentCheck()
                } else {
                    ElMessage.error('获取支付二维码失败')
                    qrCodeLoading.value = false
                }
            } catch (error) {
                console.error('支付宝支付失败:', error)
                ElMessage.error('支付失败')
                qrCodeLoading.value = false
            }
        }

        // 微信支付
        const handleWxPay = async () => {
            try {
                const data = {
                    out_trade_no: paymentData.value.tid,
                    amount: paymentData.value.price
                }

                const res = await wxPayApi(data)
                if (res.data.return_code === 'SUCCESS') {
                    paymentData.value.ewm = 'data:image/png;base64,' + res.data.code_url_img
                    qrCodeLoading.value = false
                    startPaymentCheck()
                } else {
                    ElMessage.error('获取支付二维码失败')
                    qrCodeLoading.value = false
                }
            } catch (error) {
                console.error('微信支付失败:', error)
                ElMessage.error('支付失败')
                qrCodeLoading.value = false
            }
        }

        // 选择支付方式
        const selectPaymentMethod = (method) => {
            if (selectedPaymentMethod.value === method) return
            
            selectedPaymentMethod.value = method
            
            // 如果已有订单，重新生成二维码
            if (paymentData.value.tid) {
                qrCodeLoading.value = true
                if (method === 'wechat') {
                    handleWxPay()
                } else {
                    handleAlipay()
                }
            }
        }

        // 开始支付检查
        const startPaymentCheck = () => {
            // 设置5分钟倒计时
            countdown.value = 300
            
            // 开始倒计时
            countdownTimer = setInterval(() => {
                if (countdown.value > 0) {
                    countdown.value--
                } else {
                    // 支付超时，清理所有状态
                    cleanupPayment()
                    ElMessage.warning('支付超时，请重新选择套餐')
                }
            }, 1000)
            
            // 每3秒检查一次支付状态
            paymentCheckTimer = setInterval(() => {
                checkPaymentStatus()
            }, 3000)
        }

        // 检查支付状态
        const checkPaymentStatus = async () => {
            if (!paymentData.value.tid) return
            
            try {
                const data = {
                    out_trade_no: paymentData.value.tid
                }

                if (selectedPaymentMethod.value === 'alipay') {
                    const res = await queryPayApi(data)
                    if (res.data.code == '200') {
                        handlePaymentSuccess()
                    }
                } else {
                    const res = await wxQueryPayApi(data)
                    if (res.data.trade_state == 'SUCCESS') {
                        handlePaymentSuccess()
                    }
                }
            } catch (error) {
                console.error('检查支付状态失败:', error)
            }
        }

        // 处理支付成功
        const handlePaymentSuccess = () => {
            // 保存订单信息用于显示
            const orderInfo = {
                oid: paymentData.value.oid,
                price: paymentData.value.price / 100 // 转换为元单位显示
            }
            
            // 清除定时器和状态
            cleanupPayment()
            
            ElMessage.success('VIP开通成功！')
            
            // 触发更新用户信息事件
            emit('updateUserInfo')
            
            // 关闭弹窗
            emit('update:modelValue', false)
            
            // 显示成功提示
            ElMessageBox.alert(
                `<div style="text-align: center; padding: 20px;">
                    <div style="font-size: 48px; color: #67C23A; margin-bottom: 16px;">
                        <i class="el-icon-success"></i>
                    </div>
                    <h3 style="margin: 0 0 16px; color: #333;">VIP开通成功！</h3>
                    <p style="margin: 0; color: #666;">
                        订单号：${orderInfo.oid}<br>
                        支付金额：¥${orderInfo.price}<br>
                        感谢您的支持！
                    </p>
                </div>`,
                '开通成功',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '好的'
                }
            )
        }

        // 格式化倒计时
        const formatCountdown = computed(() => {
            const minutes = Math.floor(countdown.value / 60)
            const seconds = countdown.value % 60
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        })

        // 检查滚动状态
        const checkScrollState = () => {
            if (!planContainer.value) return
            
            const container = planContainer.value
            const scrollLeft = container.scrollLeft
            const scrollWidth = container.scrollWidth
            const clientWidth = container.clientWidth
            
            // 简化边界检测
            showLeftArrow.value = scrollLeft > 10
            showRightArrow.value = scrollWidth > clientWidth && scrollLeft < scrollWidth - clientWidth - 10
        }

        // 向左滚动
        const scrollLeft = () => {
            if (!planContainer.value) return
            
            const container = planContainer.value
            const currentLeft = container.scrollLeft
            
            if (currentLeft <= 10) return
            
            // 简单策略：每次滚动容器宽度的70%
            const scrollAmount = container.clientWidth * 0.7
            const targetLeft = Math.max(0, currentLeft - scrollAmount)
            
            container.scrollTo({
                left: targetLeft,
                behavior: 'smooth'
            })
            
            setTimeout(checkScrollState, 300)
        }

        // 向右滚动
        const scrollRight = () => {
            if (!planContainer.value || isScrolling.value) return
            
            isScrolling.value = true
            const container = planContainer.value
            const currentLeft = container.scrollLeft
            const maxScrollLeft = container.scrollWidth - container.clientWidth
            
            if (currentLeft >= maxScrollLeft - 10) {
                isScrolling.value = false
                return
            }
            
            // 使用更大的滚动量，确保一次到位
            const scrollAmount = Math.min(container.clientWidth * 0.8, maxScrollLeft - currentLeft)
            const targetLeft = currentLeft + scrollAmount
            
            // 保存目标位置
            savedScrollLeft.value = targetLeft
            
            // 直接设置scrollLeft，避免任何动画
            container.scrollLeft = targetLeft
            
            // 立即再次确认位置
            setTimeout(() => {
                if (container.scrollLeft !== targetLeft) {
                    container.scrollLeft = targetLeft
                }
                checkScrollState()
                isScrolling.value = false
            }, 10)
        }

        // 监听滚动事件
        const handleScroll = () => {
            checkScrollState()
        }

        // 组件挂载时获取套餐数据
        onMounted(() => {
            fetchVipPlans()
            
            // 监听页面关闭事件，确保清理定时器
            const handleBeforeUnload = () => {
                isComponentDestroyed.value = true
                cleanupPayment()
            }
            window.addEventListener('beforeunload', handleBeforeUnload)
            
            // 存储事件处理器引用，用于清理
            window._vipModalBeforeUnloadHandler = handleBeforeUnload
        })

        // 监听套餐数据变化，更新滚动状态
        watch(vipPlans, () => {
            setTimeout(() => {
                // 恢复保存的滚动位置
                if (planContainer.value && savedScrollLeft.value > 0) {
                    planContainer.value.scrollLeft = savedScrollLeft.value
                }
                checkScrollState()
                // 移除旧的监听器，添加新的
                if (planContainer.value) {
                    planContainer.value.removeEventListener('scroll', handleScroll)
                    planContainer.value.addEventListener('scroll', handleScroll)
                }
            }, 100)
        }, { deep: true })

        // 监听弹窗显示状态
        watch(visible, (newVal) => {
            if (newVal) {
                setTimeout(checkScrollState, 100)
                // 弹窗打开时，如果有选中的套餐，创建订单
                if (selectedPlan.value && !paymentData.value.oid) {
                    createOrderTimeout = setTimeout(() => {
                        if (!isComponentDestroyed.value) {
                            createVipOrder()
                        }
                    }, 500) // 稍微延迟，确保UI渲染完成
                }
            } else {
                // 弹窗关闭时清理支付状态
                cleanupPayment()
            }
        })

        // 监听套餐选择变化，只有在弹窗打开状态下才创建订单
        watch(selectedPlan, (newVal, oldVal) => {
            if (newVal && newVal !== oldVal && visible.value && !isComponentDestroyed.value) {
                // 清除之前的支付状态
                cleanupPayment()
                
                // 创建新订单
                createOrderTimeout = setTimeout(() => {
                    if (!isComponentDestroyed.value) {
                        createVipOrder()
                    }
                }, 100)
            }
        })

        // 组件卸载时清理定时器
        onUnmounted(() => {
            // 设置销毁标志，防止异步操作继续执行
            isComponentDestroyed.value = true
            
            cleanupPayment()
            
            // 移除页面关闭事件监听器
            if (window._vipModalBeforeUnloadHandler) {
                window.removeEventListener('beforeunload', window._vipModalBeforeUnloadHandler)
                window._vipModalBeforeUnloadHandler = null
            }
        })

        return {
            visible,
            selectedPlan,
            vipPlans,
            defaultAvatar,
            loading,
            planContainer,
            showLeftArrow,
            showRightArrow,
            isScrolling,
            savedScrollLeft,
            selectedPaymentMethod,
            qrCodeLoading,
            countdown,
            paymentData,
            handleVisibilityChange,
            handleClose,
            handleLogin,
            handleOverlayClick,
            handleConfirm,
            getSelectedPlanPrice,
            getFeatureName,
            getAccountTypeName,
            fetchVipPlans,
            scrollLeft,
            scrollRight,
            checkScrollState,
            createVipOrder,
            selectPaymentMethod,
            formatCountdown,
            cleanupPayment
        }
    }
})
</script>

<style scoped>
/* VIP弹窗动画 */
.vip-modal-enter-active, .vip-modal-leave-active {
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}

.vip-modal-enter-from, .vip-modal-leave-to {
    opacity: 0;
}

.vip-modal-enter-active .vip-container,
.vip-modal-leave-active .vip-container {
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}

.vip-modal-enter-from .vip-container,
.vip-modal-leave-to .vip-container {
    opacity: 0;
    transform: scale(0.8) translateY(30px);
}

/* 遮罩层 */
.vip-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
}

/* 主容器 */
.vip-container {
    background: linear-gradient(180deg, #FFD6BD 0%, #ffffff 30%, #FFFFFF 70%, #FFFFFF 100%);
    border-radius: 8px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    max-width: 964px;
    width: 100%;
    max-height: 72vh;
    display: flex;
    position: relative;
}

/* 左侧面板 - 背景图 */
.vip-left-panel {
    width: 320px;
   
    color: white;
    padding: 30px 25px 0px;
    position: relative;
    overflow-y: auto;
    border-radius: 24px 0 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.vip-header {
    margin-bottom: 30px;
    text-align: center;
}

.vip-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0 0 8px 0;
    line-height: 1.2;
}

.vip-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
    font-weight: 400;
}

.benefits-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 0;
    flex: 1;
}

.benefit-card {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s;

    height: 57px;
}

.benefit-card:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
}

.benefit-icon {
    width: 16px;
    height: 16px;
    object-fit: contain;
    flex-shrink: 0;
}

.benefit-content {
    flex: 1;
}

.benefit-title {
    font-size: 12px;
    font-weight: 600;
    color: #D78E5C;
    margin-bottom: 2px;
}

.benefit-desc {
    font-size: 11px;
    color: #999999;
    line-height: 1.3;
}

.login-status {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    margin-top: auto;
    flex-shrink: 0;
}

.user-avatar-small {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
}

.user-avatar-small img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.login-info {
    flex: 1;
}

.login-text {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
}

.login-desc {
    font-size: 12px;
    color: #666;
}

.login-link {
    font-size: 14px;
    color: #4285f4;
    cursor: pointer;
    font-weight: 500;
    transition: color 0.3s;
}

.login-link:hover {
    color: #1a73e8;
}

/* 右侧面板 */
.vip-right-panel {
    flex: 1;
    border: 1px solid rgba(196, 190, 190, 0.2);

    padding: 40px 10px 10px 10px;
    position: relative;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    border-radius: 0 24px 24px 0;
    /* 隐藏滚动条 */
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.vip-right-panel::-webkit-scrollbar {
    display: none;
}

.close-btn {
    position: absolute;
    top: 5px;
    right: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    color: #64748b;
    z-index: 10;
}

.close-btn:hover {
    background: #ef4444;
    border-color: #ef4444;
    color: white;
    transform: rotate(90deg) scale(1.1);
}

.close-icon {
    width: 18px;
    height: 18px;
    transition: all 0.3s ease;
}

.close-btn:hover .close-icon {
    filter: brightness(0) invert(1); /* 悬停时变为白色 */
}

.user-info-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
}

.user-info-header .user-avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;

    position: relative;
}

.user-info-header .user-avatar::after {
    content: '';
    position: absolute;
    inset: -4px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    z-index: -1;
}

.user-info-header .user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-details .user-name {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
}

.user-details .user-id {
    font-size: 12px;
    color: #999;
    margin-bottom: 8px;
}

.vip-status {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #e74c3c;
    margin-bottom: 4px;
}

.normal-status {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 4px;
}

.vip-icon {
    color: #f39c12;
}

.normal-icon {
    color: #64748b;
}

.vip-expire {
    font-size: 12px;
    color: #666;
}

/* 套餐选择容器 */
.plan-selection-container {
    margin-bottom: 30px;
}

/* 套餐选择 */
.plan-selection {
    display: flex;
    flex-direction: row;
    gap: 16px;
    overflow-x: auto;
    overflow-y: visible;
    padding: 16px;
    scroll-behavior: smooth;
    /* 隐藏滚动条 */
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.plan-selection::-webkit-scrollbar {
    display: none;
}

.plan-wrapper {
    position: relative;
    cursor: pointer;
    flex: 0 0 auto;
    min-width: 182px;
}

.offer-badge {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(180deg, #4B473F 0%, #211F1C 100%);
    border-radius: 0px 20px 0px 20px;
    border: 1px solid #4E4941;
    color: white;
    font-size: 9px;
    padding: 6px 16px;
    z-index: 10;
    white-space: nowrap;
    font-weight: 500;
}

.recommend-badge {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    border-radius: 0px 20px 0px 20px;
    border: 1px solid #CA915E;
    color: white;
    font-size: 9px;
    padding: 6px 16px;
    z-index: 10;
    white-space: nowrap;
    font-weight: 500;
}

.plan-card {
    background: linear-gradient(180deg, #FFE1B7 0%, #FEF9F0 100%);
    border-radius: 20px;
   
    padding: 30px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    min-height: 220px;
}

.plan-card:hover {
    border-color: #FFB366;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 179, 102, 0.2);
    border: 2px solid #FFD7A2;
}

.plan-card.active {
    border-color: #FFB366;
    background: linear-gradient(180deg, #e3a34e 0%, #FFF5E6 100%);
    transform: translateY(-2px);
  
    border: 4px solid #FFD7A2;
}

.plan-header {
    text-align: center;
}

.plan-card .plan-name {
    font-size: 18px;
    font-weight: 600;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 8px;
}

.plan-card .plan-description {
    font-size: 12px;
    color: #666;
    line-height: 1.4;
}

.plan-card .plan-price-section {
    text-align: center;
}

.plan-card .current-price {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 2px;
    line-height: 1;
    margin-bottom: 4px;
}

.plan-card .currency-symbol {
    font-size: 14px;
    font-weight: 600;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.plan-card .price-number {
    font-size: 40px;
    font-weight: 600;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.plan-card .original-price {
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
}

.plan-card .plan-features {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 8px 0;
}

.plan-card .feature-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.plan-card .feature-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #CA915E;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: #CA915E;
    background: rgba(202, 145, 94, 0.1);
}

.plan-card .feature-icon.water-drop {
    font-size: 16px;
}

.plan-card .feature-item span {
    font-size: 11px;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 500;
}

.plan-card .plan-details {
    text-align: center;
}

.plan-card .price-per-day {
    font-size: 12px;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.4;
}

/* 加载状态 */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    width: 100%;
}

.loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #f3f4f6;
    border-top: 3px solid #3b82f6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 12px;
}

.loading-text {
    color: #64748b;
    font-size: 14px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* 支付部分 */
.payment-section {
    border-top: 1px solid #f0f0f0;
    padding-top: 20px;
}

.payment-info {
    margin-bottom: 0;
}

.payment-amount-text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: baseline;
    gap: 2px;
}

.payment-amount-text .currency-symbol {
    font-size: 14px;
    font-weight: 600;
}

.payment-amount-text .price-number {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.payment-content {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.payment-methods-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.qr-code {
    width: 160px;
    height: 160px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
 
    flex-shrink: 0;
}

.qr-mock {
    width: 140px;
    height: 140px;
    background: #333;
    border-radius: 6px;
    position: relative;
}

.qr-mock::before,
.qr-mock::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border: 3px solid white;
}

.qr-mock::before {
    top: 6px;
    left: 6px;
}

.qr-mock::after {
    bottom: 6px;
    right: 6px;
}

.qr-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
}

.payment-methods {
    display: flex;

    gap: 12px;
    flex: 1;
}

.payment-method {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #666;
    padding: 12px 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s;
    background: #F0F0F0;
    width: 120px;
    height: 40px;
}

.payment-method:hover {
    border: 2px solid #005DFF
}

.payment-method.active {
    border: 2px solid #005DFF
}

.payment-method i {
    font-size: 18px;
}

.payment-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.payment-countdown {
    font-size: 12px;
    color: #f59e0b;
    font-weight: 600;
    margin-top: 8px;
    text-align: left;
}

.agreement {
    font-size: 12px;
    color: #999;
    line-height: 1.4;
    text-align: left;
    margin-top: 8px;
}

.agreement-link {
    color: #1890ff;
    text-decoration: none;
}

.agreement-link:hover {
    text-decoration: underline;
}

.action-buttons {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.cancel-btn,
.invoice-btn,
.complete-payment-btn {
    padding: 12px 20px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;
}

.cancel-btn {
    background: #f8fafc;
    color: #94a3b8;
    border: 1px solid #f1f5f9;
}

.cancel-btn:hover {
    background: #f1f5f9;
    color: #64748b;
}

.invoice-btn {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
}

.invoice-btn:hover {
    background: #f8fafc;
    color: #475569;
}

.complete-payment-btn {
    background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.complete-payment-btn:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

@media (max-width: 768px) {
    .vip-overlay {
        padding: 16px;
    }
    
    .vip-container {
        flex-direction: column;
        max-height: 90vh;
        border-radius: 16px;
    }
    
    .vip-left-panel {
        width: 100%;
        padding: 24px;
        border-radius: 16px 16px 0 0;
    }
    
    .benefits-grid {
        grid-template-columns: 1fr;
        gap: 8px;
    }
    
    .vip-right-panel {
        padding: 24px;
        border-radius: 0 0 16px 16px;
    }
    
    .user-info-header {
        flex-direction: column;
        text-align: center;
        gap: 12px;
    }
    
    .plan-selection {
        gap: 12px;
        flex-direction: column;
    }
    
    .plan-wrapper {
        min-width: auto;
        flex: none;
    }
    
    .payment-content {
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
    
    .qr-code {
        width: 140px;
        height: 140px;
    }
    
    .payment-methods {
        width: 100%;
        max-width: 300px;
    }
    
    .action-buttons {
        flex-direction: column;
        gap: 8px;
    }
    
    .cancel-btn,
    .invoice-btn,
    .complete-payment-btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .vip-overlay {
        padding: 12px;
    }
    
    .vip-container {
        border-radius: 12px;
    }
    
    .vip-left-panel,
    .vip-right-panel {
        padding: 20px;
    }
    
    .vip-title {
        font-size: 20px;
    }
    
    .benefit-card {
        padding: 10px;
    }
    
    .benefit-title {
        font-size: 13px;
    }
    
    .benefit-desc {
        font-size: 11px;
    }
    
    .user-info-header .user-avatar {
        width: 60px;
        height: 60px;
    }
    
    .user-details .user-name {
        font-size: 16px;
    }
    
    .plan-card {
        padding: 16px;
    }
    
    .current-price {
        font-size: 28px;
    }
    
    .close-btn {
        top: 16px;
        right: 16px;
        width: 36px;
        height: 36px;
    }
}
</style>
